var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInjured(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 4,
    fill: "#383A36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6 9.8H16.8V8.4C16.8 7.63 16.17 7 15.4 7H12.6C11.83 7 11.2 7.63 11.2 8.4V9.8H8.4C7.63 9.8 7 10.43 7 11.2V19.6C7 20.37 7.63 21 8.4 21H19.6C20.37 21 21 20.37 21 19.6V11.2C21 10.43 20.37 9.8 19.6 9.8ZM12.6 8.4H15.4V9.8H12.6V8.4ZM16.1 16.1H14.7V17.5C14.7 17.885 14.385 18.2 14 18.2C13.615 18.2 13.3 17.885 13.3 17.5V16.1H11.9C11.515 16.1 11.2 15.785 11.2 15.4C11.2 15.015 11.515 14.7 11.9 14.7H13.3V13.3C13.3 12.915 13.615 12.6 14 12.6C14.385 12.6 14.7 12.915 14.7 13.3V14.7H16.1C16.485 14.7 16.8 15.015 16.8 15.4C16.8 15.785 16.485 16.1 16.1 16.1Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5_142"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInjured);
export default __webpack_public_path__ + "static/media/injured.ab0a56201f3b146dbb20ca858fc82935.svg";
export { ForwardRef as ReactComponent };